import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=56f72194&scoped=true&"
import script from "./Quote.vue?vue&type=script&lang=ts&"
export * from "./Quote.vue?vue&type=script&lang=ts&"
import style0 from "./Quote.vue?vue&type=style&index=0&id=56f72194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f72194",
  null
  
)

export default component.exports